import { useState, useCallback } from 'react';

export const useModal = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('info');

  const showModal = useCallback((message, type = 'info') => {
    setModalMessage(message);
    setModalType(type);
    setModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  return {
    modalOpen,
    modalMessage,
    modalType,
    showModal,
    closeModal
  };
};